import { cx } from '../../lib/cx';

export type ButtonVariant = 'primary' | 'accent' | 'secondary' | 'ghost' | 'danger';

export function buttonClass({
  variant = 'primary',
  size = 'md',
  fullWidth,
  className,
}: {
  variant?: ButtonVariant;
  size?: 'md' | 'sm' | 'lg';
  fullWidth?: boolean;
  className?: string;
}): string {
  return cx(
    'btn',
    `btn-${variant}`,
    size === 'sm' && 'btn-sm',
    size === 'lg' && 'min-h-[52px] text-lg',
    fullWidth && 'w-full',
    className,
  );
}
